import { combineReducers } from 'redux';

import config from './config';
import filterOptions from './filter-options';
import filter from './filter';
import posts from './posts';
import page from './page';

const reducer = combineReducers({ config, filter, filterOptions, posts, page });
export default reducer;
